import { ProductGroupExtendedSelection } from "@components/order_entry/ProductGroupExtendedSelection/ProductGroupExtendedSelection";
import ProductGroupViewer from "@components/order_entry/ProductGroupViewer/ProductGroupViewer";
import { MultiProductGroupViewer } from "@components/order_entry/MultiProductGroupViewer/MultiProductGroupViewer";
import IErrorDTO from "@models/DTO/IErrorDTO";
import { IAddBulkItems } from "@models/IAddBulkItems";
import ICatalog_Item from "@models/ICatalog_Item";
import IOrder from "@models/IOrder";
import ISupplierModel from "@models/ISupplierModel";
import IWarehouse from "@models/IWarehouse";
import ProductGroupComponentEnum from "@models/ProductGroupComponentEnum";
import { Socket } from "socket.io-client";

type Props = {
    supplierModel: ISupplierModel;
    catalogItem: ICatalog_Item;
    order: IOrder;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    socket: Socket;
    warehouses: IWarehouse[];
    addItems: (items: IAddBulkItems[]) => void;
    orientation?: "horizontal" | "vertical";
};

export const ProductGroupSelector = ({ supplierModel, catalogItem, order, notifyFn, socket, warehouses, addItems, orientation }: Props) => {
    if (catalogItem.product_group_type === "multi") {
        return (
            <MultiProductGroupViewer
                orderModel={order}
                productGroupModel={catalogItem}
                addBulkItems={addItems}
                hideTitle={true}
                noInputPadding={true}
                clearOnAdd={true}
                orientation={orientation}
            />
        );
    }

    if (supplierModel.group_component === ProductGroupComponentEnum.MODAL) {
        return (
            <ProductGroupExtendedSelection
                catalogItem={catalogItem}
                order={order}
                notifyFn={notifyFn}
                socket={socket}
                warehouses={warehouses}
                addToCart={addItems}
                inSidebarViewer={true}
            />
        );
    } else {
        return (
            <ProductGroupViewer
                orderModel={order}
                productGroupModel={catalogItem}
                addBulkItems={addItems}
                hideTitle={true}
                noInputPadding={true}
                clearOnAdd={true}
                orientation={orientation}
            />
        );
    }
};
